import { Component, Input, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/shared/services/general.service';
import { AdDefaults } from '../ad-default';


@Component({
    selector: 'general',
    templateUrl: './general.component.html',
    styleUrls: ['./general.component.scss']
})
export class GeneralComponent extends AdDefaults  implements OnInit  {

    @Input() info : any;
    @Input() list : any;
    @Input() title : any = 'Comodidades';
    @Input() swiperConfig : any;


    hasHighlight = false;
    imagesGeneral = [];

    constructor( 
        protected gs : GeneralService
    ){
        super(gs);
    }

    slideActive = 0;
    
    ngOnInit(){
        super.ngOnInit();
        this.imagesGeneral = this.info.imagesGeneral.filter(item => !this.info.imagesHighlight.filter(itemi => itemi.fileId == item.fileId).length && !this.info.videosGeneral.filter(itemi => itemi.fileId == item.fileId).length);

        if(this.imagesGeneral?.length==1)
            this.swiperConfig.slidesPerView = 1;
    }

}